import { Box } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import BoltIcon from "@mui/icons-material/Bolt";

/**
 * Filter funnel with a small bolt overlay — Quick Filter control icon.
 */
const QuickFilterIcon = ({ fontSize = 20, sx = {} }) => {
  return (
    <Box
      component="span"
      sx={{
        position: "relative",
        display: "inline-flex",
        width: fontSize,
        height: fontSize,
        lineHeight: 0,
        ...sx,
      }}
    >
      <FilterAltOutlinedIcon
        sx={{
          fontSize,
          color: "inherit",
        }}
      />
      <BoltIcon
        sx={{
          position: "absolute",
          right: -4,
          bottom: -3,
          fontSize: Math.round(fontSize * 0.7),
          color: "#6148F6",
        }}
      />
    </Box>
  );
};

export default QuickFilterIcon;
